import * as Bixby from '$/core';

export abstract class PreferredDataSiteClientService {
  private static baseUrl = `${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_PREFERREDDATASITECLIENTCONTROLLER}`;

  public static async getAll(): Promise<Bixby.Models.PreferredDataSiteClient[]> {
    const route = Bixby.API.ServerRoute.forAction(this.baseUrl);
    return await Bixby.API.get(route);
  }

  public static async getAvailableClients(): Promise<Bixby.Models.PreferredClientSlim[]> {
    const route = Bixby.API.ServerRoute.forAction(`${this.baseUrl}/available`);
    return await Bixby.API.get(route);
  }

  public static async save(items: Bixby.Models.PreferredDataSiteClientItem[]): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(this.baseUrl);
    return await Bixby.API.put(route, items);
  }
}
